export default __webpack_public_path__ + "static/media/README.cd721575.md";